export function formatZipcode(zipcode: string) {
  return zipcode.replace(/\D/g, '').replace(/^(\d{5})(\d)/, '$1-$2').slice(0, 9);
}